export interface StoreIndicatorTenant {
  domain?: string | null;
  status?: string | null;
  metadata?: { businessName?: string | null } | null;
}

export interface StoreIndicator {
  /** What the merchant calls their store. */
  name: string;
  /** First letter of the name, for the store tile. */
  initial: string;
  /** Storefront domain, only while the tenant is live. */
  domain: string | null;
  isTrial: boolean;
}

const LIVE_STATUSES = new Set(['active', 'trial']);

export function resolveStoreIndicator(
  tenant: StoreIndicatorTenant | null | undefined,
  channelCode: string,
): StoreIndicator {
  const domain = tenant?.domain && LIVE_STATUSES.has(tenant.status ?? '') ? tenant.domain : null;
  const name = tenant?.metadata?.businessName?.trim() || tenant?.domain || channelCode;
  return {
    name,
    initial: Array.from(name)[0]?.toLocaleUpperCase() ?? '',
    domain,
    isTrial: tenant?.status === 'trial',
  };
}
